import React, { useEffect, useState } from 'react'
import { StepForm } from '../StepForm'
import { useFormContext } from 'react-hook-form'
import { OptionType } from 'spa/member/components/Select/styled'
import styled from 'styled-components'
import { SelectForm } from 'spa/member/components/SelectForm'
import { KarteInputForm } from 'spa/member/components/KarteInputForm'
import { MultiCheckBoxForm } from 'spa/member/components/MultiCheckBoxForm'
import { RadioForm } from 'spa/member/components/RadioForm'
import { DateForm } from 'spa/member/components/DateForm'
import { FormType } from '../types'

type Props = {
  formType: FormType
}

const StyledFormOuter = styled.div`
  > *:not(:last-child) {
    margin-bottom: 32px;
  }
`
const WorkDaysRecommendationMessage: React.FC = () => (
  // TODO tailwindcssに移行し切ったら、id属性を削除する
  // TODO v2->v4にアップデートしたら、style属性を削除しcustom-value `px-[5.5px]` を採用する(参考: https://tailwindcss.com/docs/margin#using-a-custom-value)
  <div id="work-days-recommendation-message" className="bg-tech-silver-10 py-1 mb-XS text-gray-800 text-sm text-left leading-6" style={{ paddingLeft: '5.5px', paddingRight: '5.5px' }}>
    <strong className="text-tech-red-100 font-bold">週4日以上</strong>の稼働をご検討いただけると、紹介できる案件が<strong className="text-tech-red-100 font-bold">最大約1.5倍</strong>になります！
  </div>
)

export const StyledFirstForm: React.FC<Props> = (props) => {
  const { setValue, getValues, trigger, formState: { dirtyFields, isLoading } } = useFormContext()
  const [lessWorkDays, setLessWorkDays] = useState(false)

  useEffect(() => {
    if (!isLoading) {
      setLessWorkDays((getValues('work_days_of_week') || []).length < 4)
    }
  }, [isLoading])

  const generateHoursPerWeekOptions = (min: number, max: number, step: number, unit: string = ''): OptionType[] => {
    const numberOptions = Array.from({ length: (max - min) / step + 1 }, (_, i) => {
      const number = min + i * step

      return {
        label: `${number}${unit}`,
        value: number.toString()
      }
    })

    return [{ label: '選択してください', value: '' }, { label: `${min - 1}時間以下`, value: `${min - 1}` }, ...numberOptions]
  }

  const minWorkHoursPerWeekOptions = generateHoursPerWeekOptions(8, 40, 1)
  const maxWorkHoursPerWeekOptions = generateHoursPerWeekOptions(8, 40, 1)

  const workDaysOfWeekOptions = [
    { name: 'work_days_of_week' ,label: '月', value: '0', type: 'normal' },
    { name: 'work_days_of_week' ,label: '火', value: '1', type: 'normal' },
    { name: 'work_days_of_week' ,label: '水', value: '2', type: 'normal' },
    { name: 'work_days_of_week' ,label: '木', value: '3', type: 'normal' },
    { name: 'work_days_of_week' ,label: '金', value: '4', type: 'normal' },
    { name: 'work_days_of_week' ,label: '土', value: '5', type: 'normal' },
    { name: 'work_days_of_week' ,label: '日', value: '6', type: 'normal' },
    { name: 'work_days_of_week', label: '曜日をすべて選択', resetLabel: '曜日をすべて解除', value: 'all', type: 'all' },
  ]
  const officeDaysOfWeekOptions = [
    { name: 'office_days_of_week' ,label: '月', value: '0', type: 'normal' },
    { name: 'office_days_of_week' ,label: '火', value: '1', type: 'normal' },
    { name: 'office_days_of_week' ,label: '水', value: '2', type: 'normal' },
    { name: 'office_days_of_week' ,label: '木', value: '3', type: 'normal' },
    { name: 'office_days_of_week' ,label: '金', value: '4', type: 'normal' },
    { name: 'office_days_of_week' ,label: '土', value: '5', type: 'normal' },
    { name: 'office_days_of_week' ,label: '日', value: '6', type: 'normal' },
    { name: 'office_days_of_week' ,label: 'なし', value: '7', type: 'reset' },
    { name: 'office_days_of_week', label: '曜日をすべて選択', resetLabel: '曜日をすべて解除', value: 'all', type: 'all' },
  ]

  const remoteWorkPreferenceOptions = [
    { label: '固定でなければ必要に応じて出社の相談も可能', value: 'flexible' },
    { label: 'オンボーディング期間や初日は出社可能', value: 'onboarding_only' },
    { label: '出社は完全に不可能', value: 'fully_remote' },
  ]
  const availableTimeOptions = [
    { label: '平日日中', value: 'weekday_daytime' },
    { label: '基本は平日夜間/土日だが平日日中のミーティングは可能', value: 'evening_or_weekend_mtg_flexible' },
    { label: '平日夜間/土日のみ', value: 'evening_or_weekend' },
  ]

  return (
    <StepForm formType={props.formType} title="現在のご状況">
      <StyledFormOuter>
        <DateForm
          name='start_date'
          label='稼働開始時期'
          required
          inputProps={{
            min: new Date().toISOString().split('T')[0],
          }}
          rules={{
            required: 'この質問は必須です',
            validate: (value) => {
              if (dirtyFields.start_date) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const selectedDate = new Date(value);
                return selectedDate >= today || '過去の日付は選択できません';
              }
              return true
            }
          }}
          dataCy="start-date"
        />
        <SelectForm
          name='min_work_hours_per_week'
          label='週の最小稼働時間'
          options={minWorkHoursPerWeekOptions}
          required
          rules={{
            required: 'この質問は必須です',
          }}
          onChange={(e) => {
            const hoursPerMonth = Number(e.target.value) * 4
            setValue('_min_work_hours_per_month', hoursPerMonth)
            getValues('max_work_hours_per_week') && trigger('max_work_hours_per_week')
          }}
          dataCy="min-work-hours-per-week"
        />
        <SelectForm
          name='max_work_hours_per_week'
          label='週の最大稼働時間'
          options={maxWorkHoursPerWeekOptions}
          required
          rules={{
            required: 'この質問は必須です',
            validate: (value: string) => {
              const minHours = getValues('min_work_hours_per_week')
              return !minHours || Number(value) >= Number(minHours) ||
                '週の最大稼働時間が週の最小稼働時間を下回っています'
            }
          }}
          onChange={(e) => {
            const hoursPerMonth = Number(e.target.value) * 4
            setValue('_max_work_hours_per_month', hoursPerMonth)
          }}
          dataCy="max-work-hours-per-week"
        />
        <KarteInputForm
          name='_min_work_hours_per_month'
          label='1か月で稼働可能な累計時間（最小）'
          noBadge={true}
          annotationNote="※週の最小稼働時間 x 4週分で計算"
          inputProps={{
            type: 'number',
            disabled: true,
          }}
          dataCy="min-work-hours-per-month"
        />
        <KarteInputForm
          name='_max_work_hours_per_month'
          label='1か月で稼働可能な累計時間（最大）'
          noBadge={true}
          annotationNote="※週の最大稼働時間 x 4週分で計算"
          inputProps={{
            type: 'number',
            disabled: true,
          }}
          dataCy="max-work-hours-per-month"
        />
        <MultiCheckBoxForm
          name='work_days_of_week'
          label='稼働可能な曜日'
          annotationNote='※複数選択可'
          options={workDaysOfWeekOptions}
          rules={{
            required: 'この質問は必須です',
            validate: (value: number[]) => value.length > 0 || 'この質問は必須です'
          }}
          onChange={() => {
            const workDays = getValues('work_days_of_week')
            const allSelected = workDays.includes('all')
            setLessWorkDays(workDays.length < 4 && !allSelected)
          }}
          messageInMiddle={lessWorkDays && <WorkDaysRecommendationMessage />}
          required
          dataCy="work-days-of-week"
        />
        <MultiCheckBoxForm
          name='office_days_of_week'
          label='稼働先オフィスへの出社が可能な曜日'
          annotationNote='※複数選択可'
          options={officeDaysOfWeekOptions}
          rules={{
            required: 'この質問は必須です',
            validate: (value: number[]) => value.length > 0 || 'この質問は必須です'
          }}
          required
          dataCy="office-days-of-week"
        />
        <RadioForm
          name='remote_work_preference'
          label={(<>フルリモートを希望の方へ<br />下記3つから一番近いものをお答えください</>)}
          options={remoteWorkPreferenceOptions}
          dataCy="remote-work-preference"
        />
        <RadioForm
          name='available_time'
          label='稼働可能な時間帯'
          options={availableTimeOptions}
          required
          rules={{
            required: 'この質問は必須です'
          }}
          dataCy="available-time"
        />
      </StyledFormOuter>
    </StepForm>
  )
}
